import React, { useState } from "react";

import { Dialog, Notify } from "../../components/index";
import { Form, Input } from "antd";
import homeStore from "../../stores/homeStore";
import { addArticlesApi } from "../../apis";

import "./dialog.scss";
interface Props {
  visible: boolean;
  onSuccess?: () => void;
}

const AddCaseDialog: React.FC<Props> = (props: Props) => {
  const { onSuccess = () => {} } = props;
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const { setAddCase } = homeStore();

  const [isPosted, setIsPosted] = useState(true);

  const onCancel = () => {
    form.resetFields();
    setAddCase(false);
  };

  const onFinish = async (values: any) => {
    if (isPosted) {
      setIsPosted(false);
      const { originalLink } = values;
      try {
        await addArticlesApi({ original_link: originalLink });
        // 接口调用成功
        onSuccess();
      } catch (error: any) {
        if (error.msg) {
          Notify.error({
            message: error.msg,
            className: "notify-not-description",
            duration: 3,
          });
        }
      }
      onCancel();
    }
  };

  const onFieldsChange = async () => {
    const { originalLink } = form.getFieldsValue();
    setIsPosted(
      !!originalLink &&
        form.getFieldsError().filter(({ errors }) => errors.length).length === 0
    );
  };

  return (
    <Dialog
      {...props}
      style={{ padding: "15px 14px 30px" }}
      onCancel={onCancel}
    >
      <div className="add-case-dialog">
        <div className="add-case-dialog__title">收录内容</div>
        <Form
          name="addCase"
          onFinish={onFinish}
          onFieldsChange={onFieldsChange}
          autoComplete="off"
          form={form}
          layout="vertical"
        >
          <Form.Item
            label="案例URL"
            name="originalLink"
            rules={[
              { required: true, message: "请输入您要推荐的文章链接地址" },
              {
                pattern:
                  /^(https?:\/\/)([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/i,
                message: "您提交的链接格式不对，请重新提交",
              },
            ]}
          >
            <TextArea
              style={{ height: 100, resize: "none" }}
              placeholder="请输入您要推荐的文章链接地址"
            />
          </Form.Item>
        </Form>
        <div
          className={`${isPosted ? "add-case-dialog__btn" : "add-case-dialog__btn--disable"}`}
          onClick={() => form.submit()}
        >
          提交
        </div>
      </div>
    </Dialog>
  );
};

export default AddCaseDialog;
